import React, { useContext } from 'react';
import { Grid, Paper, CircularProgress, Typography, Box, useTheme, useMediaQuery } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import ChatMessages from './ChatMessages';
import UserList from './UserList';
import IconButtonStyled from '../general/IconButtonStyled';
import { Launch } from '@material-ui/icons';
import AppContext from "../../components/appContext";
import ButtonStyled from '../general/ButtonStyled';

const ChatHistoriqueView = ({
  users,
  currentUser,
  handleViewScreen,
  groupedMessages,
  filteredMessages,
  loadingMessages,
  userSelectedHistoy,
  handleSelectUserHistory,
  showChat,
}) => {
  const myContext = useContext(AppContext);
  const openSidebar = myContext.openSidebar;
  const theme = useTheme();
  const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const styleBoxContent = {
    width: openSidebar ? "calc(100vw - 260px)" : querysmDown ? "100vw": "calc(100vw - 50px)",
  }

  return (
    <Paper style={styleBoxContent} className="styleBoxContent">
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            Historique
            {showChat && <Box>
              <ButtonStyled
                aria-describedby="history-screen"
                variant="outlined"
                onClick={() => handleViewScreen('full')}
                style={{ marginRight: 5 }}
                iconSize={16}
                position="left"
                color='grisBtn'
              >
                Messagerie
                <Launch style={{ marginLeft: 15 }} />
              </ButtonStyled>
              <IconButtonStyled
                aria-describedby="full-screen"
                variant="outlined"
                onClick={() => handleViewScreen('small')}
                tooltipTitle="Messagerie"
                style={{ width: 32, height: 32, padding: 5 }}
                iconSize={16}
                position="left"
              >
                <SystemUpdateAltIcon />
              </IconButtonStyled>
            </Box>}

          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <UserList
              users={users}
              selectedUser={userSelectedHistoy}
              handleSelectUser={handleSelectUserHistory}
            />
          </Grid>
          <Grid item xs={8} style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1 }}>
              {loadingMessages ? (
                <CircularProgress />
              ) : (
                <ChatMessages
                  groupedMessages={groupedMessages}
                  filteredMessages={filteredMessages}
                  currentUser={currentUser}
                />
              )}
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ChatHistoriqueView;